import { Box, Flex } from "@chakra-ui/react";
import React from "react";
import { InspirationStore, inspirationStore } from "@/modules/editor/stores/inspiration";
import { genBlock } from "@/utils/bem";
import { useTranslate } from "@/utils/lang";
import { Editor_Words } from "@/utils/lang/editor";
import { EditorGallery } from "../Gallery";
import { observer } from "mobx-react-lite";
import { loginStore } from "@/modules/login/store";
import { AlbumPanel } from "../Albums";

const block = genBlock("pl-inspiration");
type TabConfigType = Array<{
  label: Editor_Words;
  value: InspirationStore["curTab"];
}>;
const tabConfig: TabConfigType = [
  {
    value: "gallery",
    label: Editor_Words["inspiration_tab_gallery"],
  },
  {
    value: "album",
    label: Editor_Words["inspiration_tab_album"],
  },
];
const Inspiration: React.FC = () => {
  const { translate } = useTranslate();
  const { curTab, setCurTab } = inspirationStore;
  return (
    <Flex flexDir="column" className={block()} h="100%">
      {loginStore.isGuest ? null : (
        <Flex
          className={block("header")}
          h="40px"
          mx="16px"
          pb="16px"
          mb="16px"
          borderBottom="1px solid"
          borderColor="border.seperator"
        >
          {tabConfig.map((tab) => {
            const isChecked = tab.value === curTab;
            return (
              <Box
                p="2px 16px"
                rounded="full"
                key={tab.value}
                color={isChecked ? "text.disabled" : "text.primary"}
                bg={isChecked ? "text.primary" : "transparent"}
                fontSize="12px"
                fontWeight={500}
                cursor="pointer"
                onClick={() => {
                  setCurTab(tab.value);
                }}
              >
                {translate(tab.label)}
              </Box>
            );
          })}
        </Flex>
      )}
      {curTab === "gallery" && (
        <EditorGallery h={loginStore.isGuest ? "100%" : "calc(100% - 56px)"} />
      )}
      {!loginStore.isGuest && curTab === "album" && <AlbumPanel h="calc(100% - 56px)" />}
    </Flex>
  );
};

export const InspirationPanel = observer(Inspiration);
